import * as React from 'react';
import "./Header.css";
import logo from "../assets/Logo.png";
import {Paper,TextField,Button,Box} from '@mui/material';
import {useState} from 'react';
import UploadVideoDialog from './UploadVideoDailog.js';

const Header =({handleSearch})=>
{
    const [open,setOpen]=useState(false);
    const [debounceTimeout, setDebounceTimeout] = useState();
    const debounceSearch = (event, debounceTimeout) => {
      if (debounceTimeout!== 0)
      {
        clearTimeout(debounceTimeout)
      }
      // need not to be async
      const timeout = setTimeout(async () => {
        handleSearch(event);
      }, 500);
      setDebounceTimeout(timeout);
    };
  
    return(
        <>
          <Paper elevation={2}>
            <Box className='Header'>
            <Box>
             <img src={logo} alt='logo' className='img'></img>
             </Box>
             <Box fullwidth='true' sx={{ flex: '0 1 500px' }} id="searchBox">
             <TextField size='small' label="Search" variant="filled" fullWidth sx={{ m: 1 }} className="searchBar" onChange={(e)=>debounceSearch(e.target.value,debounceTimeout)}/>
             </Box>
             <Box>
             <Button id='upload-btn'  type='button' variant="contained" sx={{bgcolor:'#4CA3FC'}} onClick={()=>setOpen(true)}>Upload</Button>
             </Box>
            </Box>
            </Paper>
            <UploadVideoDialog
				open={open}
				onClose={() => setOpen(false)}
				maxWidth='xs'
				fullWidth ></UploadVideoDialog>
        </>
    )
}

export default Header;